module.exports = __webpack_public_path__ + "img/virgin-media.f206583.svg";